import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { SwitchView } from './switch-view.action';

export function switchViewReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__SWITCH_VIEW,
        SwitchView
    >,
): TranscriptDialogState {
    try {
        return {
            ...state,
            view: action.payload.view,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
